import React from "react";
// import PortableText from "@sanity/block-content-to-react";
import SanityPortableText from "../SanityPortableText";

const TexteUI = ({ input }) => {
  return (
    <section className='texteUI section text-sm-lg md:text-lg scrollY-'>
      <div className='inner'>
        <div className='scrollY'>
          <div className='px-sm md:p-md'>
            <SanityPortableText input={input.texte} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TexteUI;
